import _extends from "@babel/runtime/helpers/esm/extends";
import Logger from './Logger';

function ResError(_ref) {
  var _ref$code = _ref.code,
      code = _ref$code === void 0 ? 500 : _ref$code,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? 'Unexpected error' : _ref$error;
  this.code = code;
  this.message = error;
  this.stack = new Error().stack;
}

ResError.prototype = Object.create(Error.prototype);
ResError.prototype.constructor = ResError;
var invalidTokenCallback = null;

function setInvalidTokenCallback(callback) {
  if (typeof callback === 'function') {
    invalidTokenCallback = callback;
  }
}

function hasError(code) {
  return code >= 400 && code <= 599;
}

function getOptions(options) {
  if (!options.headers) {
    // eslint-disable-next-line no-param-reassign
    options.headers = {};
  }

  return _extends({}, options, {
    headers: _extends({
      'Content-Type': options.headers.contentType || 'application/json'
    }, options.headers)
  });
}

function resolveRequest(promise) {
  return new Promise(function (resolve, reject) {
    promise.then(function (res) {
      if (hasError(res.status)) {
        res.json().then(function (error) {
          if (res.status === 401 && invalidTokenCallback) {
            invalidTokenCallback(error);
          }

          reject(new ResError({
            code: res.status,
            error: error
          }));
        })["catch"](function (error) {
          reject(new ResError({
            code: res.status,
            error: error
          }));
        });
      } else {
        res.text().then(function (data) {
          // If it's a valid JSON, parse it and return the json
          // If not JSON, return it as plain text
          try {
            var json = data ? JSON.parse(data) : {};

            if (process.env.NODE_ENV !== 'production') {
              setTimeout(function () {
                return resolve(json);
              }, 500);
            } else {
              resolve(json);
            }
          } catch (error) {
            if (data) {
              resolve(data);
            } else {
              Logger.error(error);
              reject(error);
            }
          }
        })["catch"](function (error) {
          Logger.error(error);
        });
      }
    })["catch"](function (error) {
      reject(error);
    });
  });
}

function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options = _extends({}, getOptions(options), {
    method: 'GET'
  });

  var query = '';
  var keys = Object.keys(params);
  keys.forEach(function (key, index) {
    if (index === 0) query = '?';
    query += "".concat(key, "=").concat(params[key]);
    if (index < keys.length - 1) query += '&';
  });
  return resolveRequest(fetch(url + query, _options));
}

function post(url) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options = _extends({}, getOptions(options), {
    method: 'POST',
    body: JSON.stringify(body)
  });

  return resolveRequest(fetch(url, _options));
}

function put(url) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options = _extends({}, getOptions(options), {
    method: 'PUT',
    body: JSON.stringify(body)
  });

  return resolveRequest(fetch(url, _options));
}

function remove(url) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options = _extends({}, getOptions(options), {
    method: 'DELETE',
    body: JSON.stringify(body)
  });

  return resolveRequest(fetch(url, _options));
}

export { setInvalidTokenCallback, get, post, put, remove };